import { render, staticRenderFns } from "./ContentCreateForms.vue?vue&type=template&id=4ec5f662"
import script from "./ContentCreateForms.vue?vue&type=script&lang=js"
export * from "./ContentCreateForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports